import { LoadingInterstitialRoot } from './LoadingInterstitial.styles'
import Image from 'next/image'
import Trans from 'next-translate/Trans'
import { useTranslation } from 'hooks/useTranslation'
import teddy from '../../../../../public/assets/icons/brand-refresh/teddy.webp'
import heart from '../../../../../public/assets/icons/brand-refresh/heart-red.webp'
import health from '../../../../../public/assets/icons/brand-refresh/health-cross-red.webp'
import steak from '../../../../../public/assets/icons/brand-refresh/steak-red.webp'
import { ENV } from '../../../../constants/EnvHelp'

export type LoadingInterstitialProps = {
  petName: any
  popupOpen: string
}

export const LoadingInterstitial = ({ petName, popupOpen }: LoadingInterstitialProps) => {
  const { t } = useTranslation()
  return (
    <LoadingInterstitialRoot
      className={popupOpen}
    >
      <div className="cv-1-2-crafting-popup">
        <div className="cv-1-2-crafting-plan">
          <div className="cv-1-2-container">
            <div className="crafting-plan-popup">
              <div className="crafting-plan-top">
                <h1>
                  <Trans
                    i18nKey="meal-plan:step-3.interstitial.title"
                    values={{ petname: petName }}
                  />
                </h1>
                <div className="crafting-plan-teddy">
                  <Image
                    className="meal-plan:step-3.interstitial.teddy"
                    src={teddy}
                    alt={t('meal-plan:step-3.interstitial.teddy')}
                    width={68}
                    height={44.5}
                  />
                </div>
                <div className="progress-bar">
                  <div className={`progress-fill ${ENV.isStaging && 'fill-fast'}`}></div>
                </div>
              </div>
              <div className="crafting-plan-bottom">
                <div className="crafting-plan-data">
                  <div className="plan-content">
                    <div className="icon">
                      <Image height={50} width={50} src={heart} alt={t('meal-plan:step-3.interstitial.heart')} />
                    </div>
                    <p>{t('meal-plan:step-3.interstitial.balanced-meals')}</p>
                  </div>
                  <div className="plan-content">
                    <div className="icon">
                      <Image height={50} width={49} src={health} alt={t('meal-plan:step-3.interstitial.cross')} />
                    </div>
                    <p>{t('meal-plan:step-3.interstitial.nutrition')}</p>
                  </div>
                  <div className="plan-content">
                    <div className="icon">
                      <Image height={50} width={50} src={steak} alt={t('meal-plan:step-3.interstitial.meat')} />
                    </div>
                    <p>{t('meal-plan:step-3.interstitial.sourced')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingInterstitialRoot>
  )
}
